import { api_GET } from "api/axios.js";

const local_api =
{
    getListAtivosByUsuarioId: function(id){
        const promise = new Promise((resolve, reject) => { 
            api_GET(`local/GetListAtivosByUsuarioId/${id}`).then(result => {
                resolve(result)
            });
        });

        return promise;
    }
}

export default local_api
